import {LatLngExpression} from 'leaflet'
import React, {useEffect} from 'react'
import {MapContainer, TileLayer, useMap} from 'react-leaflet'

interface Props {
  height?: string
  minHeight?: string | number
  initialPosition: LatLngExpression
  zoom?: number
}

export const ZOOM_ONE_MARKER = 13
export const ZOOM_MANY_MARKERS = 6

const InvalidateSizeOnMount: React.FC = () => {
  const map = useMap()

  useEffect(() => {
    const t = window.setTimeout(() => {
      map.invalidateSize()
    }, 0)

    return () => window.clearTimeout(t)
  }, [map])

  return null
}

export const GenericMap: React.FC<React.PropsWithChildren<Props>> = ({children, height = '600px', minHeight = 300, initialPosition, zoom = 13}) => {
  return (
    <MapContainer
      center={initialPosition}
      zoom={zoom}
      scrollWheelZoom={false}
      style={{
        width: '100%',
        height,
        minHeight,
      }}
    >
      <InvalidateSizeOnMount />
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {children}
    </MapContainer>
  )
}
